import React from "react";
import { Button, TextField, Checkbox } from "@material-ui/core";

import { authHeaders, config } from "../../helpers";

import ErrorPanel from "../../components/ErrorPanel";
import { getDollarValue } from "../../helpers";
import { openConfirm } from "../../components/confirmBox/ConfirmBox";

import { stripeKeys } from "../../helpers/keys";

import axios from "axios";

import ScriptLoader from "react-script-loader-hoc";
import { getUserRegion } from "helpers/userStorage";

import TermsOfUse from "home/components/TermsOfUse";

const Checkout = (props) => {
  const {
    shoppingCart = {},
    paymentActions,
    payments,
    onPaymentCompleted,
    onCancel,
    userManager,
  } = props;

  React.useEffect(() => {
    // actions.getUserCredits();
  }, []);

  const [email, email_set] = React.useState("");
  const [emailConfirm, emailConfirm_set] = React.useState("");
  const [submitClicked, submitClicked_set] = React.useState(false);

  const { cart, loading } = shoppingCart;
  const { portfolios = [] } = cart;

  const nonFreePortfolios = portfolios;

  const [termsChecked, termsChecked_set] = React.useState(false);

  const total =
    shoppingCart.data && !loading
      ? shoppingCart.data.costPerPortfolio * nonFreePortfolios.length +
        shoppingCart.data.totalTaxes
      : 0;
  const amountDue = shoppingCart.data ? shoppingCart.data.total : 0; // && !loading ? shoppingCart.userCredits > total ? 0 : total - shoppingCart.userCredits : 0;
  //eslint-disable-next-line
  var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  const emailValid = !!userManager.user || re.test(email);
  const emailConfirmValid = !!userManager.user || email === emailConfirm;

  if (!shoppingCart.data) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div>
        <div>Payment Summary</div>
        {nonFreePortfolios.length > 0 && (
          <div
            style={{
              display: "flex",
              padding: 10,
              fontSize: 14,
              borderTop: "1px solid #d4d4d4",
              marginTop: 10,
            }}
          >
            <div style={{ width: "100%" }}>
              Portfolio Analysis x {nonFreePortfolios.length}
            </div>
            <div style={{ width: 75, textAlign: "right" }}>
              {getDollarValue(
                shoppingCart.data.costPerPortfolio * nonFreePortfolios.length
              )}
            </div>
          </div>
        )}
        {shoppingCart.data.creditsUsed > 0 && (
          <div>
            <div
              style={{
                display: "flex",
                padding: 10,
                fontSize: 14,
                borderTop: "1px solid #d4d4d4",
                marginTop: 10,
              }}
            >
              <div style={{ width: "100%" }}>User Credits</div>
              <div style={{ width: 75, textAlign: "right", color: "red" }}>
                -{getDollarValue(shoppingCart.data.creditsUsed)}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                paddingLeft: 10,
                paddingRight: 10,
                fontSize: 14,
              }}
            >
              <div style={{ width: "100%" }}>Subtotal</div>
              <div style={{ width: 75, textAlign: "right" }}>
                {getDollarValue(
                  shoppingCart.data.subTotal - shoppingCart.data.creditsUsed
                )}
              </div>
            </div>
          </div>
        )}
        {shoppingCart.data.taxItems.map((e) => (
          <div
            key={`ti2_${e.name}`}
            style={{ display: "flex", padding: 10, fontSize: 14 }}
          >
            <div style={{ width: "100%", fontWeight: "bold" }}>{e.name}</div>
            <div style={{ width: 75, textAlign: "right" }}>
              {getDollarValue(e.value)}
            </div>
          </div>
        ))}

        {shoppingCart.userCredits > 0 && (
          <div
            style={{
              display: "flex",
              padding: 10,
              fontSize: 14,
              borderTop: "1px solid #d4d4d4",
            }}
          >
            <div style={{ width: "100%" }}>Total</div>
            <div style={{ width: 75, textAlign: "right" }}>
              {getDollarValue(total)}
            </div>
          </div>
        )}
        {shoppingCart.userCredits > 0 && (
          <div style={{ display: "flex", padding: 10, fontSize: 14 }}>
            <div style={{ width: "100%" }}>Credits Available</div>
            <div style={{ width: 75, textAlign: "right" }}>
              {getDollarValue(shoppingCart.userCredits)}
            </div>
          </div>
        )}
        <div
          style={{
            display: "flex",
            padding: 10,
            fontSize: 16,
            borderTop: "1px solid #d4d4d4",
          }}
        >
          <div style={{ width: "100%" }}>Total Amount Due</div>
          <div style={{ width: 75, textAlign: "right", fontWeight: "bold" }}>
            {getDollarValue(shoppingCart.data.total, true)}
          </div>
        </div>
        {!userManager.user && (
          <div
            style={{
              padding: 10,
              fontSize: 16,
              borderTop: "1px solid #d4d4d4",
              borderBottom: "1px solid #d4d4d4",
            }}
          >
            <div>Email Address</div>
            <div>
              <TextField
                id="outlined-email"
                margin="normal"
                variant="outlined"
                fullWidth={true}
                autoComplete="email"
                type="email"
                style={{ marginTop: 5 }}
                value={email}
                onChange={(event) => {
                  email_set(event.target.value);
                }}
                inputProps={{
                  style: {
                    padding: 10,
                  },
                }}
              />
            </div>
            <div style={{ fontSize: 12 }}>
              Your receipt and a link to your reports will be sent to this email
              address
            </div>
            <div style={{ marginTop: 5 }}>Confirm Email</div>
            <div>
              <TextField
                disabled={!emailValid}
                id="outlined-email-conf"
                margin="normal"
                autoComplete="email"
                variant="outlined"
                fullWidth={true}
                type="email"
                style={{ marginTop: 5 }}
                value={emailConfirm}
                onChange={(event) => {
                  emailConfirm_set(event.target.value);
                }}
                inputProps={{
                  style: {
                    padding: 10,
                  },
                }}
              />
            </div>
          </div>
        )}
        {emailValid && emailConfirmValid && (
          <div style={{ marginTop: 10 }}>
            <div style={{ display: "flex" }}>
              <div>
                <Checkbox
                  color="primary"
                  checked={termsChecked}
                  onChange={(event) => {
                    termsChecked_set(!termsChecked);
                    // actions.setPortfolioValue(props, portfolio.portfolioNumber, "addtionalBenchmarksBypass", event.target.checked);
                  }}
                />
              </div>
              <div
                style={{
                  fontSize: 14,
                  fontStyle: "italic",
                  marginTop: 15,
                  display: "flex",
                }}
              >
                I agree to the{" "}
                <div
                  style={{
                    color: "#3e51b5",
                    cursor: "pointer",
                    textDecoration: "underline",
                    marginLeft: 5,
                  }}
                  onClick={(e) => {
                    openConfirm({
                      description: (
                        <div style={{ margin: -20 }}>
                          <TermsOfUse isModal={true} />
                        </div>
                      ),
                      isAlert: true,
                    });

                    e.preventDefault();
                  }}
                >
                  Terms and Conditions
                </div>
              </div>
            </div>
          </div>
        )}
        {payments.error && (
          <div style={{ margin: 30 }}>
            <ErrorPanel error={payments.error} />
          </div>
        )}
        {!emailValid && (
          <div style={{ margin: 30 }}>
            <ErrorPanel error={{ data: "Valid email address is required" }} />
          </div>
        )}
        {emailValid && !emailConfirmValid && (
          <div style={{ margin: 30 }}>
            <ErrorPanel error={{ data: "Your emails do not match" }} />
          </div>
        )}
        {amountDue === 0 && (
          <div style={{ textAlign: "right", marginTop: 15 }}>
            <Button
              color={"secondary"}
              variant={"outlined"}
              style={{ marginLeft: 10, float: "right" }}
              onClick={() => {
                onCancel && onCancel();
              }}
            >
              Cancel
            </Button>
            <Button
              color={"primary"}
              variant={"outlined"}
              onClick={() => {
                if (!termsChecked) {
                  openConfirm({
                    title: "",
                    isAlert: true,
                    description:
                      "You must agree to the terms and conditions to complete this transaction.",
                  });
                  return;
                }

                paymentActions.processPaymentByCredits({
                  portfolios,
                  onPaymentReceived: (data) => {
                    // actions.clear();
                    onPaymentCompleted(data);
                  },
                });
              }}
            >
              Submit Order
            </Button>
          </div>
        )}
        {amountDue > 0 && (
          <div>
            <div style={{ marginTop: 15, whiteSpace: "nowrap" }}>
              <Button
                color={"secondary"}
                variant={"outlined"}
                style={{ marginLeft: 10, float: "right" }}
                onClick={() => {
                  onCancel && onCancel();
                }}
              >
                Cancel
              </Button>
              <Button
                style={{ float: "right" }}
                color={"primary"}
                variant={"outlined"}
                disabled={!emailValid || !emailConfirmValid || submitClicked}
                onClick={() => {
                  if (!termsChecked) {
                    openConfirm({
                      title: "",
                      isAlert: true,
                      description:
                        "You must agree to the terms and conditions to complete this transaction.",
                    });
                    return;
                  }

                  submitClicked_set(true);

                  const requestOptions = {
                    method: "POST",
                    headers: true ? { "Content-Type": "application/json" } : {},
                    data: JSON.stringify({
                      portfolios,
                      emailAddress: email,
                      currency: getUserRegion(),
                    }),
                    url: `${config.apiUrl}/payment/createStripeSession`,
                  };

                  requestOptions.headers = {
                    ...requestOptions.headers,
                    ...authHeaders(),
                  };

                  axios.request(requestOptions).then((response) => {
                    //eslint-disable-next-line
                    var stripe = Stripe(stripeKeys().stripeKey);

                    stripe
                      .redirectToCheckout({
                        // Make the id field from the Checkout Session creation API response
                        // available to this file, so you can provide it as parameter here
                        // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
                        sessionId: response.data.sessionId,
                      })
                      .then(function (result) {
                        // If `redirectToCheckout` fails due to a browser or network
                        // error, display the localized error message to your customer
                        // using `result.error.message`.
                      });
                  });
                }}
              >
                Pay {getDollarValue(amountDue)} Now
              </Button>
            </div>
            <div style={{ clear: "both" }}></div>
            <div
              style={{
                marginTop: 10,
                color: "#c4c4c4",
                fontSize: 12,
                fontFamily: "Roboto",
                textAlign: "center",
              }}
            >
              Payments are processed by{" "}
              <a href="https://stripe.com/about">© Stripe</a>. RoboPPA.com does
              not receive, collect, or retain any credit card information
              entered.
            </div>
          </div>
        )}
        {amountDue === 0 && <div></div>}
      </div>
    </div>
  );
};

export default ScriptLoader("https://js.stripe.com/v3/")(Checkout);



// WEBPACK FOOTER //
// ./src/shoppingCart/components/StripeCheckout.js